// extracted by mini-css-extract-plugin
export default {"container":"AppTabContainerItem_container__MKbsi","container_active":"AppTabContainerItem_container_active__RQKY0","appIcon":"AppTabContainerItem_appIcon__JbjHN"};